// extracted by mini-css-extract-plugin
export default {"button":"MyButton_button__QeNSl","primaryBlack":"MyButton_primaryBlack__9ybMe","medium":"MyButton_medium__SFbiI","large":"MyButton_large__9pRCM","hero":"MyButton_hero__q4ubo"};